import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PROVIDER_BRANDS } from 'src/app/consts/provider-brand.const';
import { Provider } from 'src/app/models/provider.model';
import { PatientService } from 'src/app/services/patient.service';
import { RegistrationService } from 'src/app/services/registration.service';

const { LAD_EN, LAD_PT } = PROVIDER_BRANDS;

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.css'],
  standalone: false
})
export class LogoComponent implements OnInit, OnDestroy {
  @Input('color') color: string = 'black';
  @Input('width') width: string = '110px';
  @Input() providerTitle!: string;
  @Input() providerLogo!: string;

  ladLogo = 'lad';
  private providerSubscription!: Subscription;

  constructor(
    private patientService: PatientService,
    private registrationService: RegistrationService
  ) {}

  async ngOnInit(): Promise<void> {
    let provider: Provider | null = null;
    try {
      provider = await this.patientService.getProvider();
    } catch (e) {
      provider = this.registrationService.getProvider();
    }

    this.updateLadLogo(provider);

    this.providerSubscription = this.registrationService.provider$.subscribe((p) => {
      this.updateLadLogo(p);
    });
  }

  ngOnDestroy(): void {
    this.providerSubscription?.unsubscribe();
  }

  private updateLadLogo(provider: Provider | null): void {
    if (!provider?.whiteLabel && provider?.brand) {
      this.ladLogo = provider.brand === LAD_EN ? 'lad-en' : provider.brand === LAD_PT ? 'lad-pt' : 'lad';
    }
  }
}
